module.exports = __webpack_public_path__ + "fonts/AntykwaTorunska-Regular.abeac9bb.ttf";